import React, { useState } from "react";
import Training_observation_plan_Top from "../../blog/Training_observation_plan_Top";
import PeerEvaluationForm from "../../blog/Evalution";

/* ---------------------------------------------------------------------
    Sample data for each feedback tab.
    Replace with real values once the feedback-form API endpoint is
    wired up (e.g. GET /feedback/pre-training, GET /feedback/post-training).
  --------------------------------------------------------------------- */

const feedbackTabs = [
  {
    id: "sub",
    label: "TOP Submission",
  },
  {
    id: "ev",
    label: "TOP Evaluation",
  },
];

export default function Top() {
  const [activeTab, setActiveTab] = useState(feedbackTabs[0].id);
  const activeTabData =
    feedbackTabs.find((tab) => tab.id === activeTab) || feedbackTabs[0];

  return (
    <div className="fb-wrap">
      <style>{`
        .fb-wrap {
          font-family: inherit;
        }

        .fb-card {
          background: #ffffff;
          border: none;
          border-radius: 1rem;
          box-shadow: 0 2px 12px rgba(17, 24, 39, 0.06);
          overflow: hidden;
          max-height:450em
        }

        .fb-header {
          padding: 1.5rem 1.5rem 0;
        }

        .fb-title {
          font-size: 1.1rem;
          font-weight: 700;
          color: #1e293b;
          margin: 0 0 1rem;
        }

        /* ---- Underline tab nav ---- */
        .fb-tab-nav {
          display: flex;
          gap: 2rem;
          border-bottom: 1px solid #e2e8f0;
        }

        .fb-tab-btn {
          background: none;
          border: none;
          padding: 0 0 0.85rem;
          font-size: 0.95rem;
          font-weight: 600;
          color: #94a3b8;
          cursor: pointer;
          position: relative;
          white-space: nowrap;
          transition: color 0.15s ease;
        }

        .fb-tab-btn:hover {
          color: #16a34a;
        }

        .fb-tab-btn--active {
          color: #1e293b;
          font-weight: 700;
        }

        .fb-tab-btn::after {
          content: "";
          position: absolute;
          left: 0;
          right: 0;
          bottom: -1px;
          height: 3px;
          border-radius: 999px 999px 0 0;
          background: transparent;
          transition: background-color 0.15s ease;
        }

        .fb-tab-btn--active::after {
          background: #16a34a;
        }

        /* ---- Feedback item rows ---- */
        .fb-body {
          padding: 1.25rem 1.5rem 1.5rem;
        }

        .fb-item-row {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 1rem;
          padding: 0.9rem 0.25rem;
          border-bottom: 1px dashed #eef0f3;
        }

        .fb-item-row:last-child {
          border-bottom: none;
        }

        .fb-item-title {
          font-size: 0.92rem;
          font-weight: 700;
          color: #1e293b;
        }

        .fb-item-sub {
          font-size: 0.78rem;
          color: #64748b;
          margin-top: 2px;
        }

        .fb-item-right {
          display: flex;
          align-items: center;
          gap: 0.75rem;
          flex-shrink: 0;
        }

        .fb-status {
          font-size: 0.7rem;
          font-weight: 700;
          letter-spacing: 0.03em;
          text-transform: uppercase;
          border-radius: 999px;
          padding: 3px 10px;
          white-space: nowrap;
        }

        .fb-status--submitted {
          background: #e6f4ea;
          color: #15803d;
        }

        .fb-status--pending {
          background: #f1f5f9;
          color: #64748b;
        }

        .fb-action-btn {
          border: none;
          border-radius: 8px;
          padding: 8px 16px;
          font-size: 0.82rem;
          font-weight: 700;
          color: #ffffff;
          background: #16a34a;
          cursor: pointer;
          white-space: nowrap;
          transition: box-shadow 0.15s ease, opacity 0.15s ease;
        }

        .kvs-success-details {
  text-align: left;
  background: #f9fafb;
  border: none;
  border-radius: 10px;
  padding: 16px 18px;
  margin-bottom: 24px;
}

.kvs-success-details p {
  margin: 6px 0;
  font-size: 13.5px;
  color: #374151;
}

.kvs-success-details strong {
  color: #111827;
}

        .fb-action-btn:hover {
          box-shadow: 0 6px 16px rgba(22, 163, 74, 0.3);
        }

        .fb-action-btn--outline {
          background: #ffffff;
          color: #16a34a;
          border: 1.5px solid #86efac;
        }

        @media (max-width: 576px) {
          .fb-tab-nav {
            gap: 1.1rem;
          }
          .fb-item-row {
            flex-direction: column;
            align-items: flex-start;
            gap: 0.6rem;
          }
          .fb-item-right {
            width: 100%;
            justify-content: space-between;
          }
        }

        @media (prefers-reduced-motion: reduce) {
          .fb-tab-btn,
          .fb-tab-btn::after,
          .fb-action-btn {
            transition: none;
          }
        }
      `}</style>

      <div className="fb-card">
        <div className="fb-header">
          {activeTab == "sub" && (
            <div>
              {/* <p style={{ fontSize: "16px" }}>
                <strong>Participant Names:</strong> Vishnu
              </p>
              <p style={{ fontSize: "16px" }}>
                <strong>Lead Name:</strong> Yasra Khan
              </p>
              <p style={{ fontSize: "16px" }}>
                <strong>Group No:</strong> {20}
              </p> */}
              {/* <p>
              <strong>Participants:</strong>{" "}
              {fields.groupParticipantNames.filter((n) => n.trim()).join(", ")}
            </p>
            <p>
              <strong>Problem Statement:</strong> {fields.problemStatement}
            </p>
          </div> */}
            </div>
          )}
          <div className="fb-tab-nav">
            {feedbackTabs.map((tab) => (
              <button
                key={tab.id}
                type="button"
                className={`fb-tab-btn ${
                  activeTab === tab.id ? "fb-tab-btn--active" : ""
                }`}
                onClick={() => setActiveTab(tab.id)}
              >
                {tab.label}
              </button>
            ))}
          </div>

          <div>
            {activeTab == "sub" ? (
              <Training_observation_plan_Top />
            ) : (
              <PeerEvaluationForm />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
